'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryWithSubcategories = categoryWithSubcategories;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function categoryWithSubcategories() {
    // prodFactory and getClass are created to be able to use the CategoryModel recursively
    var prodFactory = {
        getClass: function getClass() {

            var clazz = function CategoryWithSubcategories() {
                var defaults = {
                    id: 0,
                    name: '',
                    subcategories: null
                };

                _lodash2.default.extend(this, defaults);
            };

            clazz.create = function (resource) {
                var category = new clazz();
                category.id = resource.Id;
                category.name = resource.Name;

                category.subcategories = null;
                if (resource.Subcategories && resource.Subcategories.length > 0) {
                    category.subcategories = [];
                    for (var i = 0; i < resource.Subcategories.length; i++) {
                        var cat = prodFactory.getClass().create(resource.Subcategories[i]);
                        category.subcategories.push(cat);
                    }
                }

                return category;
            };

            return clazz;
        }
    };

    return prodFactory;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/categoryWithSubcategoriesModel.js
// module id = 738
// module chunks = 0